import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FundHistoryService} from '../../shared/services/fund-history.service';
import {HttpResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {AdminService} from "../../shared/services/admin.service";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopbarComponent } from '../../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../../shared/components/bottombar/bottombar.component';


@Component({
    selector: 'app-fund-details',
    templateUrl: './fund-details.component.html',
    styleUrls: ['./fund-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent
    ]
})
export class FundDetailsComponent implements OnInit {
  data;
  response;
  details;
  constructor(private route: ActivatedRoute, private fundHistoryService: FundHistoryService, private toastrService: ToastrService,
              private router: Router, private adminService: AdminService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.getDetails(id);
      this.getAdminDetails();
    });
  }

  getDetails(id) {
    this.fundHistoryService.getFund(id).subscribe(
      data => {
        this.data = data['data'][0];
      }
    );
  }

  getAdminDetails() {
    this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
      });
  }
  revertFund(id) {
    this.fundHistoryService.revertFund(id).subscribe(
      data => {
        this.response = data;
        if (this.response.status) {
          this.toastrService.success(this.response.message);
        } else {
          this.toastrService.error(this.response.message);
        }
        this.router.navigate(['fund-history/']);
      },
      (error: HttpResponse<any>) => {
        this.toastrService.error(error.statusText);
      });
  }

}
